import{e as t,s as l}from"./chunk-DXFNOYOG.js";import{m as e}from"./chunk-HBP5N4FR.js";e();l();var d=(n,r)=>{let i=r===void 0?t:r;return!(n!=null&&n.toString().indexOf(".")>=0&&n.toString().split(".").pop().length>i)};export{d as a};
//# sourceMappingURL=chunk-CAHL54QH.js.map
